import { useMemo } from "react";
import { getFinalScoreDistribution, mapRawAverageToPercentageQuestionAverage } from "../shared/model/GameStatsEvaluation";
import { VerticalDistributionComponent } from "../shared/components/VerticalDistributionComponent";

export function FinalScoreStatsComponent({ data }) {
  const percentageQuestionAverage = useMemo(() => {
    const rawAverage = (data.map(x => x.stats.finalScore).reduce((a, b) => a + b, 0) / data.length).toPrecision(4);
    return mapRawAverageToPercentageQuestionAverage(rawAverage)
  }, [data]);

  const scoresRaw = useMemo(() => data.map(x => x.stats.finalScore), [data]);
  const values = useMemo(() => getFinalScoreDistribution(scoresRaw), [scoresRaw]);

  return (
    <section className="vertical-container justify">
      <span className="small bottom-margin">Als <i>Ergebnis</i> ist die <i>zuletzt richtig beantwortete Frage</i> definiert.</span>

      <div className="vertical-container top-margin gap-1">
        <span>
          Durchschnittlich hast du die
          <span className="glow primary horizontal-padding"> {percentageQuestionAverage}%</span>
          -Frage als letzte Frage richtig beantwortet.
        </span>

        <div>
          Verteilung der erreichten <span className="">Ergebnisse</span>:
          <VerticalDistributionComponent values={values} />
        </div>
      </div>
    </section>
  );
}
